/*
 * 品种api
 * */
import request from './.request'

export function getAllVarieties() {
  return request({
    url: `/variety`,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/variety2.js